<div>
  <h1 class="search-header">{{'SCENARIO_COMPARISON.RESULTS.SEARCH.HEADER' | anessaTranslation: trigger}}</h1>
  <div *ngIf="searchData">
    <!--search criteria input-->
    <mat-form-field>
      <label for="search-criteria-input">{{'RESULTS.GENERAL.SEARCH' | anessaTranslation: trigger}}</label>
      <input
        matInput
        type="text"
        [(ngModel)]="searchCriteria"
        (ngModelChange)="onSearchChange()"
        name="search-criteria-input"
        id="search-criteria-input"
      >
    </mat-form-field>
    <!--list of selectable result items-->
    <div class="item-list-container border-outline">
      <ng-scrollbar style="height: 100%; display: block; overflow: scroll">
        <ng-container *ngIf="filteredSearchData.length < 1">
          <p>{{'SCENARIO_COMPARISON.RESULTS.SEARCH.NO_SEARCH_RESULTS' | anessaTranslation: trigger}}</p>
        </ng-container>
        <ng-container *ngFor="let item of filteredSearchData">
          <p class="list-item"
             (click)="onItemClick(item)"
          >
            {{ item.display }}
          </p>
        </ng-container>
      </ng-scrollbar>
    </div>
    <!--close button-->
    <div class="center close-button">
      <button
        class="btn-red btn-compact"
        mat-button
        type="button"
        (click)="onCloseClick()"
      >{{'SCENARIO_COMPARISON.RESULTS.SEARCH.CLOSE' | anessaTranslation: trigger}}</button>
    </div>
  </div>
</div>
